import { Accordion } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import './RapportJob.css';

interface RapportJobProps {
	// Detail affiche dans un accordion replie, pas d'accordion si absent
	children?: React.ReactNode;
	resume: string;
	testIdResume: string;
	// Obligatoire avec un detail
	titreDetail?: string;
}

/**
 * Rapport affiche a la fin d'un traitement long : un resume puis son detail
 */
const RapportJob = ({
	children,
	resume,
	testIdResume,
	titreDetail,
}: RapportJobProps) => {
	const [active, setActive] = React.useState<boolean>(false);

	return (
		<>
			<p className="resumeRapportJob" data-testid={testIdResume}>
				{resume}
			</p>
			{children && (
				<Accordion className="accordionRapportJob">
					<Accordion.Title active={active} onClick={() => setActive(!active)}>
						<Icon
							color="#004a99"
							iconSet="Lucide"
							name={active ? 'ChevronDown' : 'ChevronRight'}
							strokeWidth={3}
						/>
						{titreDetail}
					</Accordion.Title>
					<Accordion.Content active={active}>{children}</Accordion.Content>
				</Accordion>
			)}
		</>
	);
};

export default RapportJob;
